import { AsyncSelect } from "src/components/forms";
import { AsyncSelectOrTextField } from "src/components/forms/AsyncSelectOrTextField";
import { EntityWithIdAndDescription, EntityWithIdAndDescriptionFields } from "src/types";
import { OperacionLCSLHPTIFields, OperacionLCSLHPTITablaValorFields } from "../types/fields";
import { Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useWatch } from "react-hook-form";
import { OperacionLCLSHPTILimiteTipo } from "../types/dto";
import { VALOR_GUION } from "../constants";

interface TablaValorCeldaLCSLHPTIProps {
    control: any;
    index: number;
    tipoSelector: 'concentracion' | 'limite_perdida' | 'limite_holding' | 'limite_credito';
    loadOptionsMapping: Record<string, any>;
    permiteEditar: boolean;
}

const TablaValorCeldaLCSLHPTI = ({ control, index, tipoSelector, loadOptionsMapping, permiteEditar }: TablaValorCeldaLCSLHPTIProps) => {
    const loadOptions = loadOptionsMapping[tipoSelector];
    const name = `${OperacionLCSLHPTIFields.TablaValores}.${index}.${OperacionLCSLHPTITablaValorFields.Valor}`;
    const theme = useTheme();

    const valorActual = useWatch({ control, name });
    const estaCompletado = valorActual !== undefined && valorActual !== null && valorActual !== '' && valorActual !== VALOR_GUION;

    const contenedorSx = {
        borderRadius: 1,
        backgroundColor: estaCompletado ? alpha(theme.palette.success.main, 0.12) : 'transparent'
    };

    /*
        En las opciones de este workflow ya esta formateado el valor como "USD 1.200.000", pero al pasar al campo libre 
        el valor queda como el string raw p.ej.: "1200000". Para no modificar todo desde la base hasta aca, esto se formatea al momento de hacer el submit en handleCrearOperacion en NuevoSIstemaLCLSLHPTI.tsx
    */
    if (tipoSelector === 'limite_credito') {
        return (
            <Box sx={contenedorSx}>
                <AsyncSelectOrTextField<OperacionLCLSHPTILimiteTipo>
                    name={name}
                    control={control}
                    label=""
                    loadOptions={loadOptions}
                    valueField={EntityWithIdAndDescriptionFields.Description}
                    descriptionField={EntityWithIdAndDescriptionFields.Description}
                    nullOptionLabel="Otro"
                    disabled={!permiteEditar}
                    buttonType="icon"
                    textFieldProps={{
                        size: 'small',
                        currency: true,
                        prefix: 'USD',
                        saveFormattedValue: true
                        // prefix: 'USD', // Le quito el prefijo porque el espacio es muy limitado
                    }}
                />
            </Box>
        );
    }

    return (
        <Box sx={contenedorSx}>
            <AsyncSelect
                name={name}
                loadOptions={loadOptions}
                valueField={EntityWithIdAndDescriptionFields.Description}
                control={control}
                selectNotNulleable
                fullWidth
                disabled={!permiteEditar}
                size="small"
            />
        </Box>
    );
};

export default TablaValorCeldaLCSLHPTI;